<template>
    <div>
        <gift-progress-submenu
            :steps-number="stepsNumber"
            :step="step"
            :title="title"
            :previous-step="previousStep"
            :next-step="nextStep"/>
        <transition>
            <section>
                <router-view></router-view>
            </section>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GiftingSteps from '@/config/GiftingSteps';
import GiftProgressSubmenu from '@/components/partials/account/gifting/GiftProgressSubmenu';
import GiftingService from '@/services/gifting/GiftingService';
import { PRODUCT_TYPE_SINGLE, PRODUCT_TYPE_BUMPER_SINGLE } from '@/constants/Gifting';

export default {
    name: 'Gifting',
    components: {
        GiftProgressSubmenu,
    },
    data() {
        return {
            steps: GiftingSteps.steps,
            giftingService: new GiftingService(),
        };
    },
    computed: {
        ...mapGetters({
            giftingAddress: 'address/getSelectedGiftingAddress',
            incompleteGiftingData: 'gifting/getIncompleteGifting',
            incompleteGiftingId: 'gifting/getIncompleteGiftingId',
            userId: 'account/getUserId',
            selectedBoxName: 'gifting/getSelectedBoxName',
            isFreeVase: 'account/isFreeVase',
        }),
        giftType() {
            return this.$store.getters['gifting/getGiftType'];
        },
        giftTypeSteps() {
            return this.steps.filter((step) => {
                return step.enabled === true && (this.giftType === null || step.type.includes(this.giftType));
            });
        },
        nextStep() {
            return this.step < this.stepsNumber ? this.giftTypeSteps[this.stepIndex + 1].routeName : null;
        },
        previousStep() {
            return this.step > 1 ? this.giftTypeSteps[this.stepIndex - 1].routeName : null;
        },
        step() {
            return 1 + this.stepIndex;
        },
        stepIndex() {
            return this.giftTypeSteps
                .map((step) => step.routeName)
                .indexOf(this.$route.name);
        },
        stepsNumber() {
            return this.giftTypeSteps.length - 1;
        },
        title() {
            return this.giftTypeSteps[this.stepIndex]?.title;
        },
    },
    mounted() {
        this.$store.dispatch('gifting/fetchGiftDeliveryDate');
        this.$store.commit('gifting/updateCurrentStep', this.step - 1);
        this.$store.commit('gifting/updateTotalSteps', this.stepsNumber);
        this.$store.commit('gifting/updateGiftingAddress', this.giftingAddress);
        this.$store.commit('gifting/updateIncompleteGiftingData', null);
        (this.selectedBoxName === PRODUCT_TYPE_SINGLE || this.selectedBoxName === PRODUCT_TYPE_BUMPER_SINGLE) && this.isFreeVase && this.$store.commit('gifting/setAddonVase', this.isFreeVase);
        if (this.step > 1) {
            setTimeout(() => {
                this.giftingService.sendIncompleteGiftingData(this.incompleteGiftingData, this.incompleteGiftingId, this.userId)
                    .then(resp => {
                        if (resp !== null) this.$store.commit('gifting/setincompleteGiftingId', resp);
                    });
            }, 10);
        }
    },
};
</script>
